import { useNavigate } from 'react-router-dom';
import { cleareCookies, getCookies, setCookies } from '../../services/Cookies.js';
import toast from 'react-hot-toast';
import { api } from '../../api/index.js';
import { useDispatch } from 'react-redux';
import { setDecimalPlaces, setLoggedIn, setUserDetails } from "../../store/Slices/userSlice.js";
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import CryptoJS from "crypto-js";
import { LoginApi } from '../../api/request/auth.js';

export default function SessionManager() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const [render, setRender] = useState(5);
    const refreshExpiry = getCookies('refreshTime');
    let refreshTimeout;
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY
    let errorToastId = useRef(null);

    const showErrorToast = (message) => {
        if (errorToastId) {
            return;
        }
        errorToastId = toast.error(message, {
            onClose: () => {
                errorToastId = null;
            }
        });
    };

    const refreshAccessToken = async () => {
        try {
            const refreshToken = getCookies('refreshToken');
            const accessToken = getCookies('token');

            const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}api/Login/RefreshToken`, {
                refreshToken,
            }, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            setCookies('token', data.token);
            setCookies('refreshToken', data.refreshToken);
            const expiryDuration = data?.tokenExpiry * 60 * 1000;
            const bufferTime = 5 * 60 * 1000;
            const currentTime = new Date().getTime();
            const refreshTime = currentTime + expiryDuration - bufferTime;
            setCookies('refreshTime', refreshTime);
            // setRender(Math.random())
        } catch (err) {
            dispatch(setLoggedIn(false));
            cleareCookies();
            showErrorToast('Your session has expired. Please login to pick up where you left off.');
            navigate('/');
            // handleLoginSaved()
        }
    };

    // useEffect(() => {
    //     console.log(refreshExpiry, "refreshExpiry")
    //     if (refreshExpiry) {
    //         const timeUntilRefresh = refreshExpiry - new Date().getTime();
    //         console.log(timeUntilRefresh, "refreshTime")
    //         if (timeUntilRefresh > 0) {
    //             console.log("New Timer Start ", timeUntilRefresh)
    //             refreshTimeout = setTimeout(() => {
    //                 refreshAccessToken();
    //             }, timeUntilRefresh);
    //         }
    //     }
    //     return () => {
    //         clearTimeout(refreshTimeout);
    //     };
    // }, [render])

    const handleLoginSaved = async (e) => {
        // e.preventDefault();

        const savedData = localStorage.getItem("savedCredentials");
        if (!savedData) {
            toast.error("No saved login credentials found.");
            return;
        }

        try {
            const { username, password: encryptedData } = JSON.parse(savedData);

            const iv = CryptoJS.enc.Base64.parse(encryptedData.substr(0, 24));
            const encryptedPassword = encryptedData.substring(24);

            const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
            const bytes = CryptoJS.AES.decrypt(encryptedPassword, key, { iv: iv });
            const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);

            if (!decryptedPassword) {
                toast.error("Failed to decrypt saved password.");
                return;
            }

            const params = {
                login_type: "api",
                username,
                password: decryptedPassword,
            };

            const { data } = await LoginApi(params);

            if (data?.token) {
                toast.success("Login successful!");
                setCookies("username", username, { path: "/", secure: true, sameSite: "strict" });
                setCookies("token", data?.token, { path: "/", secure: true, sameSite: "strict" });
                setCookies("refreshToken", data?.refreshToken, { path: "/", secure: true, sameSite: "strict" });
                setCookies("clientId", data?.client?.id, { path: "/", secure: true, sameSite: "strict" });
                setCookies("gmtOffset", data?.gmtOffset, { path: "/", secure: true, sameSite: "strict" });

                // Set current logged-in user
                localStorage.setItem("username", username);
                localStorage.setItem("clientId", data?.client?.id);

                dispatch(setLoggedIn(true));
                dispatch(setUserDetails(data?.client));
                dispatch(setDecimalPlaces(data?.decimalPlacesForAmountFormatting));
                navigate("/dashboard");
            } else {
                toast.error("Login failed. Please check your credentials.");
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "An error occurred while logging in.";
            toast.error(errorMessage);
        }
    };
    useEffect(() => {
        const interceptor = api.interceptors.response.use(
            response => response,
            async error => {
                const originalRequest = error.config;
                if ((error.response?.status === 401 && !originalRequest._retry) || (!error.response?.status && !originalRequest._retry)) {
                    dispatch(setLoggedIn(false));
                    cleareCookies();
                    showErrorToast('Your session has expired. Please login to pick up where you left off.');
                    navigate('/');
                }
                return Promise.reject(error);
            }
        );

        return () => {
            // Eject on unmount to prevent duplicate interceptors
            api.interceptors.response.eject(interceptor);
        };
    }, []);
    useEffect(() => {
        if (!refreshExpiry) return;

        const timeUntilRefresh = refreshExpiry - new Date().getTime();
        if (timeUntilRefresh > 0) {
            refreshTimeout = setTimeout(() => {
                refreshAccessToken();
            }, timeUntilRefresh);
        }

        return () => clearTimeout(refreshTimeout);
    }, [refreshExpiry]);

    api.interceptors.response.use(
        response => response,
        async error => {
            const originalRequest = error.config;
            if ((error.response?.status === 401 && !originalRequest._retry) || (!error.response?.status && !originalRequest._retry)) {
                dispatch(setLoggedIn(false));
                cleareCookies();
                showErrorToast('Your session has expired. Please login to pick up where you left off.');
                navigate('/');
            }
            return Promise.reject(error);
        }
    );
}
